import React from "react";

import infiniteLogoAbout from "../../assets/images/infinite-logo-about.png";

import RegisterBanner from "../../components/RegisterBanner/RegisterBanner";

import { useInView } from "react-intersection-observer";
import cs from "classnames";
import { useNavigate } from "react-router-dom";

import "./About.scss";

const About = () => {
  const navigate = useNavigate();
  const { ref: backgroundRef, inView: backgroundVisibility } = useInView();
  const { ref: titleRef, inView: titleVisibility } = useInView();
  const { ref: subTitleRef, inView: subTitleVisibility } = useInView();
  const { ref: descriptionRef, inView: descriptionVisibility } = useInView();
  const { ref: outlineTitleRef, inView: outlineTitleVisibility } = useInView();
  const { ref: outlineRef, inView: outlineVisibility } = useInView();
  const { ref: downloadTitleRef, inView: downloadTitleVisibility } =
    useInView();
  const { ref: downloadRef, inView: downloadVisibility } = useInView();
  const { ref: downloadDescriptionRef, inView: downloadDescriptionVisibility } =
    useInView();

  return (
    <div className="About">
      <img
        ref={backgroundRef}
        loading="lazy"
        src={infiniteLogoAbout}
        className={cs(
          "About__background",
          backgroundVisibility && "About__background-animation",
        )}
      />

      <div className="About__container">
        <div
          ref={titleRef}
          className={cs(
            "About__title",
            titleVisibility && "About__title-animation",
          )}
        >
          About
        </div>
        <div
          ref={subTitleRef}
          className={cs(
            "About__subtitle",
            subTitleVisibility && "About__subtitle-animation",
          )}
        >
          <span>At Infinite,</span> we're not just in the business of providing
          connectivity solutions – we're pioneers shaping the future of
          connectivity itself. With an unwavering commitment to innovation and
          excellence, we stand at the forefront of the industry, setting new
          standards with every product we create.
        </div>
        <div
          ref={descriptionRef}
          className={cs(
            "About__description",
            descriptionVisibility && "About__description-animation",
          )}
        >
          What sets us apart is our relentless pursuit of perfection. From our
          cutting-edge technology to our unparalleled customer service,
          everything we do is infused with a passion for excellence. We believe
          in pushing the boundaries of what's possible, constantly striving to
          exceed expectations and deliver experiences that truly inspire.
          <br />
          <br />
          But perhaps what truly sets us apart is our ethos. We're not just a
          company; we're a community united by a shared vision of a world where
          connectivity knows no bounds. Every member of our team is driven by a
          desire to make a difference, to empower individuals and businesses
          alike to connect, communicate, and thrive in ways they never thought
          possible.
          <br />
          <br />
          In a world where connectivity is more important than ever, Infinite is
          here to lead the way. Join us on this journey as we redefine
          connectivity and shape the future together.
        </div>
        <div
          ref={outlineTitleRef}
          className={cs(
            "About__outline-title",
            outlineTitleVisibility && "About__outline-title-animation",
          )}
        >
          Feel free to reach us out
        </div>
        <div
          ref={outlineRef}
          className={cs(
            "About__outline",
            outlineVisibility && "About__outline-animation",
          )}
          onClick={() => {
            window.location.href = `mailto:${encodeURIComponent(
              "info@infiniteclouds.com",
            )}`;
          }}
          style={{ cursor: "pointer" }}
        >
          info@infiniteclouds.com
        </div>
        <div className="About__line"></div>

        <div
          ref={downloadTitleRef}
          className={cs(
            "About__download-title",
            downloadTitleVisibility && "About__download-title-animation",
          )}
        >
          Download our Products Presentation
        </div>
        <div
          ref={downloadRef}
          className={cs(
            "About__download",
            downloadVisibility && "About__download-animation",
          )}
        >
          DOWNLOAD NOW
        </div>
        <RegisterBanner />
      </div>
    </div>
  );
};

export default About;
